import React, {useEffect, useState} from 'react';
import {useLazyQuery} from "@apollo/client";
import CONSULTATION_ATTENDEES_QUERY from "../queries/consultation-with-attendees.graphql";

const WithAttendees = (WrappedComponent) => (props) => {
  const [consultationAttendees, setConsultationAttendees] = useState([]);
  const [consultationActivePersons, setConsultationActivePersons] = useState([]);
  const [consultation, setConsultation] = useState(null);

  const resolveRelationshipsAttendees = (relationships) => {
    return relationships.map(({roleCd, assignedActor: {id, name}, online}) => ({id, name, roleCd, online}))
  };

  const [getConsultationAttendees] = useLazyQuery(CONSULTATION_ATTENDEES_QUERY, {
    variables: {consultationId: parseInt(props.consultId)},
    fetchPolicy: "network-only",
    onCompleted: ({consultation: {consultationInteraction: {assignedPersonRelationships, activePersons}, ...consult}}) => {
      setConsultationAttendees(resolveRelationshipsAttendees(assignedPersonRelationships));
      setConsultationActivePersons(activePersons);
      setConsultation(consult);
    },
    onError: (error) =>{
      console.log('withAttendees: Errors', error)
    }
  });

  useEffect(() => getConsultationAttendees(), [props.consultId]);

  return(
    <WrappedComponent
      {...props}
      consultation={consultation}
      consultationAttendees={consultationAttendees}
      consultationActivePersons={consultationActivePersons}
    />
  )
}

export default WithAttendees;
